ready(function(){

	const closeModal = function() {
		const modalEl = document.getElementById("modal");
		if (modalEl) {
			// -- animate inner modal close --
			const modalInnerEl = document.getElementById("modal__inner");
			modalInnerEl.classList.add('!animate-modalInnerClose');
			setTimeout(function(){
				// -- animate modal close --
				modalEl.classList.add('!animate-modalClose');
			}, 400);
			setTimeout(function(){
				// -- remove all child nodes --
				while (modalEl.hasChildNodes()) {
					modalEl.removeChild(modalEl.firstChild);
				}
				// -- remove all classes --
				modalEl.className = '';
				// -- remove the event listener for clicks outside the modal --
				document.body.removeEventListener('click', handleOutsideModalClick);				
			}, 800);
		}
	};


	// -- handler to check if the click is outside the modal --
	const handleOutsideModalClick = function (e) {
		const modalInnerEl = document.getElementById("modal__inner");
		if (modalInnerEl && !modalInnerEl.contains(e.target)) {
			closeModal();
		}
	};	

	// -- listen for the htmx:afterSwap event --
	document.body.addEventListener('htmx:afterSwap', function (event) {
		const closeModalBtn = document.getElementById("closeModalBtn");
		if (closeModalBtn) {
			// -- close modal on close button click --
			closeModalBtn.addEventListener('click', closeModal);
			// -- close modal on click outside modal --
			document.body.addEventListener('click', handleOutsideModalClick);
		}
	});

});